export const steps = {
  "meu-plano": {
    "previous": null,
    "next": "identificacao",
    "index": 0
  },
  "meu-pacote": {
    "previous": null,
    "next": "identificacao",
    "index": 0
  },
  "pagamento": {
    "previous": "meu-plano",
    "next": "sucesso",
    "index": 1
  },
  "sucesso": {
    "previous": "pagamento",
    "next": null,
    "index": 2
  }
};
